import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Config} from "../../common/config";
import {SsrCookieService} from 'ngx-cookie-service-ssr';
import {inject, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from "@angular/common";

export const HeaderInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  let temp;
  if (isPlatformServer(inject(PLATFORM_ID))) {
    const cookieService = inject(SsrCookieService);
    const token = cookieService.get('authorization');
    temp = req.clone({
      setHeaders: {
        ...(token ? {'authorization': `Bearer ${token}`} : {}),
        'x-real-visitor-id': '' + Config.visitorId
      },
      withCredentials: true
    });
  } else {
    temp = req.clone({
      setHeaders: {
        'x-real-visitor-id': '' + Config.visitorId
      },
      withCredentials: true
    });
  }
  return next(temp);
};
